// extracted by mini-css-extract-plugin
module.exports = {"moduleBundle":"moduleBundle_moduleBundle__WOgzy","title":"moduleBundle_title__gZlkH","imageContainer":"moduleBundle_imageContainer__BoURK","image":"moduleBundle_image__aIJCf"};